const DEFAULT_API_BASE_URL =
  'https://cornflowerblue-skunk-388583.hostingersite.com/api/index.php'

function getApiOrigin(): string {
  const apiBase = process.env.REACT_APP_API_BASE_URL ?? DEFAULT_API_BASE_URL
  try {
    return new URL(apiBase).origin
  } catch {
    return ''
  }
}

function getUploadBaseUrl(): string {
  const explicit = process.env.REACT_APP_UPLOAD_BASE_URL?.trim()
  if (explicit) {
    return explicit.endsWith('/') ? explicit : `${explicit}/`
  }

  const origin = getApiOrigin()
  return origin ? `${origin}/uploads/` : '/uploads/'
}

/** Turn API upload paths/filenames into absolute URLs for <img src> and persistence. */
export function resolveUploadImageUrl(url: string): string {
  const trimmed = url.trim()
  if (!trimmed) return ''

  if (/^https?:\/\//i.test(trimmed)) return trimmed

  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`
  }

  const origin = getApiOrigin()

  if (trimmed.startsWith('/uploads/')) {
    return origin ? `${origin}${trimmed}` : trimmed
  }

  if (trimmed.startsWith('/')) {
    return origin ? `${origin}${trimmed}` : trimmed
  }

  return `${getUploadBaseUrl()}${trimmed}`
}

export function isResolvableUploadImageUrl(url: string): boolean {
  const trimmed = url.trim()
  if (!trimmed) return false
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return false
  return true
}
